import { action, computed, observable, toJS } from 'mobx';
import API from '../api';
import Account from 'stores/Account';
import { create, persist } from 'mobx-persist';
import clientPersist from 'client-persist';
clientPersist.setDriver(clientPersist.SESSIONSTORAGE);
import { getAuthState } from 'utilities/utilities';

const initState = {
	token: '',
	user: null,
	errorMessage: ''
};

const defaultInclude = ['Roles'];

export default class Auth {
	rootStore = null;

	constructor(rootStore) {
		this.rootStore = rootStore;
	}

	hydrate(): Promise {
		const hydrate = create({ storage: clientPersist });
		return hydrate('authStore', this).then(store => {
			if (store.user?.id) {
				store.user = new Account(store.user);
				return store.user.reload();
			} else return true;
		});
	}

	@persist
	@observable
	token: string = '';
	@persist
	@observable
	role: string = '';
	@persist('object')
	@observable
	user: Account = null;

	extend(data: JSON) {
		Object.assign(this, data);
	}

	@action
	async requestCode(email, password): Promise<string> {
		let response = await API.post('/Accounts/requestCode', {
			email: email,
			password: password
		});
		return true;
	}

	@action
	authenticateUserProda = async function(code): Promise<boolean> {
		let value = code.replace(/\//g, '').replace(/#/g, '');
		const url = `/ProdaActivities/getAccessTokenFromCode/${value}`;
		const response = await API.get(url);
		this.token = response.token.id;
		let user = await API.get(
			`/Accounts/${response.token.user.id}?filter=${JSON.stringify({
				include: ['Roles']
			})}`
		);
		this.user = new Account(user);
		if (this.user.role !== 'admin') {
			this.rootStore.ui.manager.consentSignature.load();
		}
		return this.token;
	};

	@action
	authenticateUser = async function(username, password, mfaCode): Promise<boolean> {
		let response;
		//second step of 2FA
		if (mfaCode) {
			response = await API.post('/Accounts/loginWithCode', {
				email: username,
				password: password,
				mfaCode: mfaCode
			});
			//first step of either manager or non-manager login
		} else {
			response = await API.post('/Accounts/loginAs', {
				email: username,
				password: password
			});
		}
		//if One Time Password is required (non-manager login flow)
		this.token = response.id;
		if (this.token === 'OTP') {
			return this.token;
		}
		let user = await API.get(
			`/Accounts/${response.user.id}?filter=${JSON.stringify({
				include: ['Roles']
			})}`
		);
		this.user = new Account(user);
		return this.token;
	};

	@computed
	get isAuthenticated() {
		return !!this.token && !!this.user;
	}

	static async passwordReset(email: string, subject: string) {
		await API.post(`/Accounts/reset`, { email, subject });
	}

	static async setPassword(newPassword: string, token: string) {
		await API.post(
			`/Accounts/reset-password?access_token=${token}`,
			{ newPassword: newPassword },
			'form-urlencoded'
		);
	}

	@action
	async logOut() {
		this.clearCredentials();
	}

	@action
	logOutTab() {
		this.extend(initState);
		this.rootStore.clear();
	}

	@action
	clearCredentials() {
		localStorage.setItem('removeSessionStorage', new Date().toTimeString());
		localStorage.removeItem('removeSessionStorage');
		this.extend(initState);
		this.rootStore.clear();
		localStorage.removeItem('authStore');
	}
}



// WEBPACK FOOTER //
// ./src/stores/Auth.js